import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import style from './Headline.module.scss';

const Headline = ({ theme = {}, text }) => {
  if (!text) return null;
  return <span className={classNames(style.headline, theme.headline)}>{text}</span>;
};

Headline.propTypes = {
  text: PropTypes.string,
  theme: PropTypes.shape({}),
};

export default Headline;
